import { useState } from "react";
import { BookOpen, ChevronDown } from "lucide-react";

/* 📖 Collapsible in-game guide — steps, win condition, payout, smart-play tip. */
const HowToPlay = ({ id, steps = [], win, payout, tip }) => {
  const [open, setOpen] = useState(false);
  return (
    <div className="rounded-lg border border-white/10 bg-[#0B0E14] overflow-hidden">
      <button data-testid={`${id}-howto-toggle`} onClick={() => setOpen((o) => !o)}
        className="w-full flex items-center gap-2 px-3 h-10 text-left hover:bg-white/5 transition-colors">
        <BookOpen className="w-3.5 h-3.5 text-[#F7B731]" />
        <span className="text-[11px] font-black tracking-tight text-white">How to play & how to win</span>
        <ChevronDown className={`w-3.5 h-3.5 text-white/40 ml-auto transition-transform ${open ? "rotate-180" : ""}`} />
      </button>
      {open && (
        <div data-testid={`${id}-howto-panel`} className="px-3 pb-3 space-y-2">
          <ol className="space-y-1.5">
            {steps.map((s, i) => (
              <li key={i} className="flex gap-2 text-[10.5px] font-mono text-white/70 leading-snug">
                <span className="w-4 h-4 mt-0.5 rounded-full bg-[#2962FF]/20 text-[#2962FF] grid place-items-center text-[9px] font-black shrink-0">{i + 1}</span>
                <span>{s}</span>
              </li>
            ))}
          </ol>
          <p className="text-[10px] font-mono text-[#089981] leading-snug"><b>You win when:</b> {win}</p>
          <p className="text-[10px] font-mono text-[#F7B731] leading-snug"><b>Payout:</b> {payout}</p>
          {tip && <p className="text-[10px] font-mono text-white/60 leading-snug">💡 <b>Smart play:</b> {tip}</p>}
          <p className="text-[9px] font-mono text-white/35 leading-snug">
            Scanner stats describe recent history only — no outcome is ever guaranteed. Set a budget, bank your greens.
          </p>
        </div>
      )}
    </div>
  );
};

export default HowToPlay;
